module.exports = __webpack_public_path__ + "img/load-img3.49764103.png";